import polyglotI18nProvider from 'ra-i18n-polyglot';
import ukrainianMessages from 'ra-language-ukrainian';

const i18nProvider = polyglotI18nProvider(() => ukrainianMessages, 'ua', [{ locale: 'ua', name: 'Ukrainian' }], {
    allowMissing: true
});

export default i18nProvider;
